import Swiper from 'swiper/bundle';

window.sliderMainInit = function() {
  if ($('.js-sliderMain').length > 0) {
    let ww = $(window).width();

    let sliderMain = $('.js-sliderMain .swiper-container');
    let isAutoplay;
    let loopVal;

    sliderMain.each(function(index, elem){
      let parent = $(elem).parents('.js-sliderMain'),
          nextBtn = parent.find('.swiper-next').addClass("js-sliderNextBtn-".concat(index)),
          nextBtnStr = ".js-sliderNextBtn-".concat(index),
          prevBtn = parent.find('.swiper-prev').addClass("js-sliderPrevBtn-".concat(index)),
          prevBtnStr = ".js-sliderPrevBtn-".concat(index),
          paginationId = parent.find('.swiper-pagination').addClass("js-sliderPagination-".concat(index)),
          paginationIdStr = ".js-sliderPagination-".concat(index),
          swiperSldes = $(elem).find('.swiper-slide').length,
          slidesWidth = $(elem).find('.swiper-slide:first-child').width() * +swiperSldes,
          fingerVal = true;

      let spaceDesktop = 24;
      isAutoplay = false;
      loopVal = false;

      if (parent.attr('data-desktop-space')) {
        spaceDesktop = +parent.attr('data-desktop-space');
      }

      if (parent.hasClass('js-swiperAutoplay')) {
        const autoplayDelay = Number(parent.data('autoplay-delay')) || 5000;
        isAutoplay = { delay: autoplayDelay, disableOnInteraction: false };
        loopVal = true;
      }

      if (slidesWidth < $(elem).width()) {
        parent.addClass('is_disabled');
        fingerVal = false;
      }

      let sliderMainSwiper = new Swiper(this, {
        slidesPerView: "auto",
        // spaceBetween: 16,
        spaceBetween: 0,
        // slidesOffsetAfter: 16,
        // slidesOffsetBefore: 16,
        followFinger: fingerVal,
        loop: loopVal,
        autoplay: isAutoplay,
        navigation: {
          nextEl: nextBtnStr,
          prevEl: prevBtnStr,
        },
        pagination: {
          el: paginationIdStr,
          type: 'bullets',
          clickable: true
        },
        breakpoints: {
          1024: {
            // spaceBetween: spaceDesktop,
            spaceBetween: 0,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0
          }
        }
      });
    });
  }
}

$(window).on('load', function () {
  sliderMainInit();
});


